module.exports = __webpack_public_path__ + "imgs/instagram2.0293681715182cdce7f3926883b82fc1.svg";